import React, { useCallback, useState, useEffect } from "react";
import "react-input-range/lib/css/index.css";
import RangeSlider from "../RangeSlider";
import useEmotiiBounds from "../../hooks/useEmotiiBounds";
import useEmotiiFrame from "../../hooks/useEmotiiFrame";
import { GifReader } from "omggif";
import useFooter from "../../hooks/useFooter";
import QuestionFooter from "../Footer/QuestionFooter";
import CryptoJS from "crypto-js";
import { useDispatch, useSelector } from "react-redux";
import { incrementPeekSlide } from "../../store/slices/slides";
import { setAssessment, updateQuestion } from "../../store/slices/assessment";

function normalizeValue(value) {
  return Math.round(((value - 0) * (6 - 1)) / (1 - 0) + 1);
}

function Emotii({
  id,
  title,
  subtitle,
  leftTitle,
  leftTitlePrefix,
  rightTitle,
  rightTitlePrefix,
  isBipolar,
  imageGifUrl,
  isVisible,
  shouldNormalizeValue,
  reverse,
}) {
  const dispatch = useDispatch();
  const [value, setValue] = useState(0.2);
  const [frames, setFrames] = useState([]);
  const [valueUpdated, setValueUpdated] = useState(false);

  const { min, max } = useEmotiiBounds(isBipolar);
  const start = isBipolar ? Math.max(0, frames.length / 2 - 1) : 0;

  useFooter(isVisible, <QuestionFooter />);

  let frame = useEmotiiFrame(
    value,
    isBipolar,
    start,
    Math.max(frames.length - 1, 0)
  );
  frame = Math.max(0, frame);
  frame = Math.min(frames.length - 1, frame);

  const imageFrame = frames && frames[frame];

  const updateValue = useCallback(
    (value) => {
      const intensity = value ?? 0;
      if (!valueUpdated) {
        dispatch(incrementPeekSlide());
      }
      setValueUpdated(true);

      let calcValue = shouldNormalizeValue
        ? normalizeValue(intensity)
        : intensity;
      if (reverse) {
        calcValue -= 1.0;
      }

      dispatch(
        updateQuestion({
          id,
          title,
          value: Math.abs(calcValue),
          imageFrame,
        })
      );
    },
    [setValue, imageFrame, frame, frames, valueUpdated]
  );

  useEffect(() => {
    if (!imageGifUrl) return;
    loadGifFrameList(imageGifUrl);
  }, [imageGifUrl]);

  const getImageHash = (base64Image) => CryptoJS.SHA256(base64Image).toString();

  const loadGifFrameList = async (gifUrl) => {
    const response = await fetch(gifUrl);
    const blob = await response.blob();
    const arrayBuffer = await blob.arrayBuffer();
    const intArray = new Uint8Array(arrayBuffer);

    const reader = new GifReader(intArray);

    const info = reader.frameInfo(0);
    const _f = new Array(reader.numFrames()).fill(0).map((_, k) => {
      const image = new ImageData(info.width, info.height);

      reader.decodeAndBlitFrameRGBA(k, image.data);

      const canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      const context = canvas.getContext("2d");

      // draw the image data onto the canvas
      context.putImageData(image, 0, 0);
      const base64Image = canvas.toDataURL();

      return { imageSrc: base64Image, hash: getImageHash(base64Image) };
    });
    setFrames(_f);
  };

  return (
    <div className={`h-full bg-${id}-content`}>
      {" "}
      <div className="block-emotti">
        <div className={`block-tip`}>
          <h1 className="">
            {title}
            <span className={subtitle ? "visible" : "invisible"}>
              {subtitle || "Inviisble text"}
            </span>
          </h1>
          <div className="block_emotti_img">
            <img
              src={imageFrame?.imageSrc}
              width={"180px"}
              alt=""
              className="m-auto"
            />
          </div>
          <div className="w-full">
            <RangeSlider
              min={min}
              max={max}
              value={value}
              step={0.01}
              onChange={setValue}
              onFinalChange={updateValue}
            />
          </div>

          <div className="pt-5 justify-between flex text-lg">
            <span className="text-left">
              <strong>
                {" "}
                <i>{leftTitlePrefix}</i>{" "}
              </strong>
              <br />
              {leftTitle}
            </span>

            <span className="text-right">
              <strong>
                <i>{rightTitlePrefix}</i>
              </strong>
              <br /> {rightTitle}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Emotii;
